import { zodResolver } from '@hookform/resolvers/zod'
import { Grid, Stack } from '@mui/joy'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { z } from 'zod'
import { AggregatorDriver } from '~/shared/api'
import { buildI18nMessage } from '~/shared/lib/i18nMessageHelper'
import { stringRequiredScheme, uuidOptionSchema } from '~/shared/lib/schemas'
import { Button } from '~/shared/ui/Buttons'
import {
  AsyncAutocompleteInput,
  DateTimePickerInput,
  FormProvider,
} from '~/shared/ui/Form'

const formSchema = z
  .object({
    aggregatorProfileId: uuidOptionSchema,
    fromDate: stringRequiredScheme,
    toDate: stringRequiredScheme,
  })
  .refine((data) => new Date(data.toDate) >= new Date(data.fromDate), {
    message: buildI18nMessage('validate.to date must be after from date'),
    path: ['toDate'],
  })

export type FormValues = {
  aggregatorProfileId: UniqueId
  fromDate: string
  toDate: string
}

type FormProps = {
  onCancel: () => void
  onSuccess: (formValues: FormValues) => void
  isSubmitting: boolean
}

export function Form({ onCancel, onSuccess, isSubmitting }: FormProps) {
  const { t } = useTranslation()
  const params = useParams<{ driverId: string }>()
  const driverId = params.driverId as string
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
  })

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <Grid container spacing={2.5}>
        <Grid xs={12}>
          <AsyncAutocompleteInput
            label='form.aggregator'
            placeholder='form.select account'
            name='aggregatorProfileId'
            fetchOptions={() =>
              AggregatorDriver.fetchOptionsByDriverId(driverId)
            }
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={12}>
          <DateTimePickerInput
            label='form.from date'
            name='fromDate'
            placeholder='form.from date'
            readOnly={isSubmitting}
            skeletonShow={isSubmitting}
            minDate={null}
          />
        </Grid>
        <Grid xs={12}>
          <DateTimePickerInput
            label='form.to date'
            name='toDate'
            placeholder='form.to date'
            readOnly={isSubmitting}
            skeletonShow={isSubmitting}
            minDate={null}
          />
        </Grid>
      </Grid>

      <br />
      <Stack direction='row' justifyContent='space-between' spacing={2}>
        <Button
          variant='gray'
          onClick={onCancel}
          disabled={isSubmitting}
          fullWidth
        >
          {t('button.cancel')}
        </Button>
        <Button variant='green' type='submit' loading={isSubmitting} fullWidth>
          {t('button.sync balance')}
        </Button>
      </Stack>
    </FormProvider>
  )
}
